<template>
  <Modal :title="title" name="REMOVE_INVOICE_MODAL" actions>
    <template v-slot:body>
      <p>{{ warningMessage }}</p>

      <v-card color="grey lighten-4" class="pa-5" elevation="0">
        <h6 class="text-uppercase grey--text">{{ $t('hausefulInvoices.customer') }}</h6>
        <p class="body-2 mb-2">{{ customer }}</p>
        <h6 class="text-uppercase grey--text">{{ $t('hausefulInvoices.host') }}</h6>
        <p class="body-2 mb-2">{{ host }}</p>
        <h6 class="text-uppercase grey--text">{{ $t('hausefulInvoices.total') }}</h6>
        <p class="body-2 mb-0">{{ total }}</p>
      </v-card>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeAllModals"
        :disabled="loading"
        elevation="0"
        color="grey"
        text
      >
        {{ $t('hausefulInvoices.actions.cancel') }}
      </v-btn>
      <v-btn
        @click="remove"
        :loading="loading"
        class="ml-5 primary"
        elevation="0"
      >
        {{ buttonLabel }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { catalogMonetary } from '@/util/catalog'

import Modal from '@/components/app/Modal'

export default {
  name: 'ModalRemoveInvoice',

  components: {
    Modal,
  },

  computed: {
    ...mapGetters(['adminInvoice']),

    host() {
      return this.adminInvoice.host?.name ?? '---'
    },

    customer() {
      return this.adminInvoice.real_estate?.name ?? '---'
    },

    total() {
      return this.adminInvoice.total ? catalogMonetary(this.adminInvoice.total) : '---'
    },
  },

  methods: {
    ...mapActions(['removeInvoices']),
    ...mapMutations(['closeAllModals']),

    remove() {
      this.loading = true
      this.removeInvoices(this.adminInvoice.id).finally(() => this.loading = false)
    },
  },

  data() {
    return {
      catalogMonetary,
      loading: false,

      title: this.$t('hausefulInvoices.modals.remove.title'),
      warningMessage: this.$t('hausefulInvoices.modals.remove.message'),
      buttonLabel: this.$t('hausefulInvoices.actions.exclude'),
    }
  }
}
</script>
